import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { customEvent } from '@utils/customEvent';

import './AlbumCustomComponent.less';

export default function AlbumCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const dynamicData = props.dynamicData;  // 动态数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  if (!customFeature.isSideslip) {
    // 非横滑
    styleObj['paddingBottom'] = transformPx2Rem(data.customFeature['padding-top'], 320);
  } else {
    // 横滑（需要根据mode计算组件高度）
    styleObj['paddingRight'] = transformPx2Rem(data.customFeature['padding-left'], 320);
    let height = null;
    if (customFeature.mode === 0) {
      height = parseInt(data.customFeature.imgHeight) + parseInt(data.customFeature['padding-top']) * 2;
    } else if (customFeature.mode === 1) {
      height = parseInt(data.customFeature.imgHeight) + (parseInt(customFeature.textHeight) || 14) * 1.6 + parseInt(data.customFeature['padding-top']) * 2;
    }
    styleObj['height'] = transformPx2Rem(height, 320);
  }
  /**
   * 单项样式
   */
  let itemWidth = null;
  if (!customFeature.isSideslip) {
  // 非横滑（需要计算单行单列宽度）
    let num = (320 - parseInt(data.customFeature['padding-left']) * (parseInt(data.customFeature['col']) + 1)) / parseInt(data.customFeature['col']);
    itemWidth = transformPx2Rem(num, 320);
  } else {
  // 横滑
    itemWidth = transformPx2Rem(data.customFeature.width, 320);
  }
  const itemStyleObj = {
    width: itemWidth,
    marginTop: transformPx2Rem(data.customFeature['padding-top'], 320),
    marginLeft: transformPx2Rem(data.customFeature['padding-left'], 320),
  };
  /**
   * 图片样式（与图片标题共同组成父容器的高度）
   */
  const imgStyleObj = {
    height: transformPx2Rem(data.customFeature.imgHeight, 320),
    borderRadius: transformPx2Rem(data.customFeature.picBorderRadius, 320),
  };
  /**
   * 组件内容处理（TODO: 应该没有动态数据，后续删减）
   */   
  let content = data.content;
  const segment = data.customFeature.segment; // 已绑定字段
  if (dynamicData && segment) {               // 当前组件有动态数据并已绑定某字段
    content = dynamicData[segment]; // TODO: 如果content为富文本，需要处理
  }
  /**
   * 返回组件
   */ 
  return (
    <div className={`custom-component album mode-${customFeature.mode} ${customFeature.isSideslip && 'sideslip'}`} style={styleObj}>
      {
        content.map((item, itemIndex) => {
          return (
            <div className="album-item" key={itemIndex} style={itemStyleObj}  onClick={() => customEvent({customFeature: item.customFeature})}>
              <img style={imgStyleObj} src={item.pic} alt={item.title}/>
              <div className="title">{item.title}</div>
            </div>
          );
        })
      }
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/album-custom-component/AlbumCustomComponent.jsx